import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox } from "vue"
import _imports_0 from '../assets/tools/zoom-in-24.png'
import _imports_1 from '../assets/tools/zoom-out-24.png'
import _imports_2 from '../assets/tools/zoom-extent-24.png'
import _imports_3 from '../assets/tools/zoom-initial-24.png'
import _imports_4 from '../assets/tools/zoom-full-24.png'
import _imports_5 from '../assets/tools/chevron-down-24.png'
import _imports_6 from '../assets/tools/chevron-up-24.png'


const _hoisted_1 = { class: "toolbar-root" }
const _hoisted_2 = { class: "toolbar-group" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  alt: " ",
  src: _imports_0
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "tool-label" }, "Zoom In", -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  alt: " ",
  src: _imports_1
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "tool-label" }, "Zoom Out", -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  alt: " ",
  src: _imports_2
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "tool-label" }, "Zoom to Area", -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  alt: " ",
  src: _imports_3
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "tool-label" }, "Reset Zoom", -1)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  alt: " ",
  src: _imports_4
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "tool-label" }, "Zoom to Fit", -1)
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = { class: "toolbar-group" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "tool-label" }, "Color Map", -1)
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "toolbar-group" }
const _hoisted_22 = { class: "checkbox-group" }
const _hoisted_23 = { class: "checkbox-item" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", {
  class: "checkbox-label",
  for: "box1"
}, "Interpolated Density", -1)
const _hoisted_25 = { class: "checkbox-item" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", {
  class: "checkbox-label",
  for: "box2"
}, "Positive Fill", -1)
const _hoisted_27 = { class: "checkbox-item" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", {
  class: "checkbox-label",
  for: "box3"
}, "Positive Color Fill", -1)
const _hoisted_29 = { class: "checkbox-item" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", {
  class: "checkbox-label",
  for: "box4"
}, "Wiggles", -1)
const _hoisted_31 = { class: "checkbox-item" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", {
  class: "checkbox-label",
  for: "box5"
}, "Negative Fill", -1)
const _hoisted_33 = { class: "checkbox-item" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", {
  class: "checkbox-label",
  for: "box6"
}, "Negative Color Fill", -1)
const _hoisted_35 = { class: "toolbar-group" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("img", {
  alt: " ",
  src: _imports_5
}, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("p", { class: "tool-label" }, "Decrease", -1)
const _hoisted_38 = [
  _hoisted_36,
  _hoisted_37
]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("p", { class: "tool-label" }, "Vertical Scale", -1)
const _hoisted_40 = { class: "tool-text-below-label" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("img", {
  alt: " ",
  src: _imports_6
}, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("p", { class: "tool-label" }, "Increase", -1)
const _hoisted_43 = [
  _hoisted_41,
  _hoisted_42
]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("img", {
  alt: " ",
  src: _imports_3
}, null, -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("p", { class: "tool-label" }, "Reset", -1)
const _hoisted_46 = [
  _hoisted_44,
  _hoisted_45
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _createElementVNode("button", {
            class: "toolbar-button",
            title: "Zoom In",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.zoomIn && _ctx.zoomIn(...args)))
          }, _hoisted_5)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("button", {
            class: "toolbar-button",
            title: "Zoom Out",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.zoomOut && _ctx.zoomOut(...args)))
          }, _hoisted_8)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("button", {
            class: "toolbar-button",
            title: "Zoom to Area",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.rubberBandZoom && _ctx.rubberBandZoom(...args)))
          }, _hoisted_11)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("button", {
            class: "toolbar-button",
            title: "Reset Zoom",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.zoomReset && _ctx.zoomReset(...args)))
          }, _hoisted_14)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("button", {
            class: "toolbar-button",
            title: "Zoom to Fit",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.zoomToFit && _ctx.zoomToFit(...args)))
          }, _hoisted_17)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _hoisted_19,
          _withDirectives(_createElementVNode("select", {
            class: "color-select",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedColorMap) = $event)),
            id: "colorMap",
            onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onColorChange()))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colorOptions, (option) => {
              return (_openBlock(), _createElementBlock("option", {
                key: option.name,
                value: option.name
              }, _toDisplayString(option.name), 9, _hoisted_20))
            }), 128))
          ], 544), [
            [_vModelSelect, _ctx.selectedColorMap]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: "box1",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.rasterProperties.interpolatedDensity) = $event)),
              onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.rasterPropertyChanged()))
            }, null, 544), [
              [_vModelCheckbox, _ctx.rasterProperties.interpolatedDensity]
            ]),
            _hoisted_24
          ]),
          _createElementVNode("div", _hoisted_25, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: "box2",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.rasterProperties.positiveFill) = $event)),
              onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.rasterPropertyChanged()))
            }, null, 544), [
              [_vModelCheckbox, _ctx.rasterProperties.positiveFill]
            ]),
            _hoisted_26
          ]),
          _createElementVNode("div", _hoisted_27, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: "box3",
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.rasterProperties.positiveColorFill) = $event)),
              onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.rasterPropertyChanged()))
            }, null, 544), [
              [_vModelCheckbox, _ctx.rasterProperties.positiveColorFill]
            ]),
            _hoisted_28
          ]),
          _createElementVNode("div", _hoisted_29, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: "box4",
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.rasterProperties.wiggle) = $event)),
              onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.rasterPropertyChanged()))
            }, null, 544), [
              [_vModelCheckbox, _ctx.rasterProperties.wiggle]
            ]),
            _hoisted_30
          ]),
          _createElementVNode("div", _hoisted_31, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: "box5",
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.rasterProperties.negativeFill) = $event)),
              onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.rasterPropertyChanged()))
            }, null, 544), [
              [_vModelCheckbox, _ctx.rasterProperties.negativeFill]
            ]),
            _hoisted_32
          ]),
          _createElementVNode("div", _hoisted_33, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: "box6",
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.rasterProperties.negativeColorFill) = $event)),
              onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.rasterPropertyChanged()))
            }, null, 544), [
              [_vModelCheckbox, _ctx.rasterProperties.negativeColorFill]
            ]),
            _hoisted_34
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_35, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _createElementVNode("button", {
            class: "toolbar-button",
            title: "scale Y Down",
            onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.scaleYDown && _ctx.scaleYDown(...args)))
          }, _hoisted_38)
        ]),
        _createElementVNode("li", null, [
          _hoisted_39,
          _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.scaleYValue), 1)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("button", {
            class: "toolbar-button",
            title: "scale Y Up",
            onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.scaleYUp && _ctx.scaleYUp(...args)))
          }, _hoisted_43)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("button", {
            class: "toolbar-button",
            title: "scaleReset",
            onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.scaleReset && _ctx.scaleReset(...args)))
          }, _hoisted_46)
        ])
      ])
    ])
  ]))
}